import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { DialogTrigger } from "react-aria-components";
import { useClickAnyWhere } from "usehooks-ts";
import IngredientPopover from "~/client/pages/DemoRecipePage/IngredientPopover";
import SectionHeading from "~/client/pages/DemoRecipePage/SectionHeading";
import { HighlightedIngredient, Step, StepContent, StepNotes, StepNumber, StepsList, } from "./styled";
const StepsPanel = ({ activeStep, ingredients, onActiveStepChange, steps, }) => {
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            block: "end",
            inline: "nearest",
            behavior: "smooth",
        });
    }, [activeStep]);
    useClickAnyWhere(() => {
        onActiveStepChange(null);
    });
    const parsedSteps = steps.map(({ content: step, ingredientHighlights: stepIngredients }) => {
        if (stepIngredients.length === 0) {
            return step;
        }
        const stepStrings = [];
        for (const [i, stepIngredient] of stepIngredients.entries()) {
            if (i === 0 && stepIngredient.start > 0) {
                stepStrings.push(step.slice(0, Math.max(0, stepIngredient.start)));
            }
            else if (i > 0 && stepIngredient.start > stepIngredients[i - 1].end) {
                stepStrings.push(step.slice(stepIngredients[i - 1].end, stepIngredient.start));
            }
            const ing = ingredients[stepIngredient.id];
            stepStrings.push(_jsxs(DialogTrigger, { children: [_jsx(HighlightedIngredient, { children: step.slice(stepIngredient.start, stepIngredient.end) }), _jsx(IngredientPopover, { placement: "top", children: _jsxs("div", { children: [ing.quantity, " ", ing.unit, " ", ing.ingredient] }) })] }, stepIngredient.id));
            if (i === stepIngredients.length - 1 &&
                stepIngredient.end < step.length) {
                stepStrings.push(step.slice(Math.max(0, stepIngredient.end)));
            }
        }
        return stepStrings;
    });
    return (_jsxs("div", { children: [_jsx(SectionHeading, { children: "Directions" }), _jsx(StepsList, { children: parsedSteps.map((step, i) => (_jsxs(Step, { "$isActive": activeStep === i, onClick: (event) => {
                        event.stopPropagation();
                        onActiveStepChange(i);
                    }, ref: activeStep === i ? ref : null, children: [_jsx(StepNumber, { children: i + 1 }), _jsxs(StepContent, { children: [_jsx("div", { children: step }), steps[i].note === undefined ? null : (_jsxs(StepNotes, { children: ["Notes: ", steps[i].note] }))] })] }, i))) })] }));
};
export default StepsPanel;
